//libs
import { Link } from "react-router-dom";
import { format } from "date-fns";
//components
import TenderStatus from "features/tenders/components/TenderStatus";
// import TenderType from "features/tenders/components/TenderType";

export default function TenderItem({ tender, type }) {
  const isTender = type === 1;
  return (
    <Link to={`/${isTender ? "tenders" : "quotations"}/${tender.id}`}>
      <div className="overflow-hidden rounded-xl border border-slate-300 p-6 ">
        <div className="flex items-center justify-between gap-x-4">
          <p className="font-light">{isTender ? 'Tender' : 'Quotation'}: {tender.tender_no}</p>
          <div className="flex items-center gap-2">
            <TenderStatus status={tender.tender_status} />
            {/* <TenderType type={"T"} bgColor={"bg-green-500"} /> */}
          </div>
        </div>
        <h4 className="font-semibold pt-6 pb-4">{tender.tender_title}</h4>
        <div className="grid grid-cols-3">
          <div className="col-span-2">
            <div className="flex flex-col gap-4">
              <div className="grid grid-cols-6">
                <div className="col-span-2">Agency:</div>
                <div className="col-span-4 font-semibold">
                  {tender.department_name || "Agency Name"}
                </div>
              </div>
              <div className="grid grid-cols-6">
                <div className="col-span-2">Published:</div>
                <div className="col-span-4 font-semibold">
                  {format(tender.start_datetime, "MMM dd, yyyy HH:mm a")}
                </div>
              </div>
              {isTender && (
                <div className="grid grid-cols-6">
                  <div className="col-span-2">Procurement Category:</div>
                  <div className="col-span-4 font-semibold">
                    {`${tender.category_name} > ${tender.sub_category_name}`}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div>
            <div className="col-span-3">
              <div className="flex flex-col gap-4">
                <div>
                  <p>Closing Date:</p>
                  <p className="text-lg font-semibold text-green-700">
                    {format(tender.end_datetime, "MMM dd, yyyy HH:mm a")}
                  </p>
                </div>
                <div>
                  <p>Mode of Submission:</p>
                  <p className="font-semibold">{tender.mode_of_submission}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
